export const ORDER_DIRECTION = {
    ASC: 'ASC',
    DESC: 'DESC',
} as const;

export type OrderDirectionKey = (typeof ORDER_DIRECTION)[keyof typeof ORDER_DIRECTION];
